export default __webpack_public_path__ + "static/media/ray15.9aa6558d.webp";